export enum SymbolicatorStatus {
  SYMBOLICATED = 'symbolicated',
  MISSING_SYMBOL = 'missing_symbol',
  UNKNOWN_IMAGE = 'unknown_image',
  MISSING = 'missing',
  MALFORMED = 'malformed',
}
